/**
 * Workflow UI constants used on the live editor path.
 * Import from here — NOT from mock.ts — in production components.
 * mock.ts re-exports these for backward-compat in stories/tests.
 */
import type { Cadence } from './types';

export const CADENCES: readonly { value: Cadence; label: string }[] = [
  { value: 'manual', label: 'Manual' },
  { value: 'hourly', label: 'Hourly' },
  { value: 'daily', label: 'Daily' },
  { value: 'weekdays', label: 'Weekdays' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

/** Matches `workflow.save` / `workflow.rename` Zod `.max(200)`. */
export const ROUTINE_NAME_MAX = 200;

/** Matches `workflow.save` / `workflow.rename` Zod `.max(280)`. */
export const ROUTINE_DESCRIPTION_MAX = 280;
